import { Box, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import {
  breweryPagePath,
  memberBreweryLinks,
  ungroupedBreweryId,
} from '../../utils/nhStyleFingerprintSnapshot';

function MemberBreweryLink({ member }) {
  return (
    <Typography variant="body2">
      <Link component={RouterLink} to={member.path}>
        {member.name} ({member.id})
      </Link>
    </Typography>
  );
}

function UngroupedBreweryLink({ identity }) {
  const breweryId = ungroupedBreweryId(identity);
  if (!breweryId) {
    return null;
  }
  return (
    <Typography variant="body2">
      <Link component={RouterLink} to={breweryPagePath(breweryId)}>
        {identity.displayName}
      </Link>
    </Typography>
  );
}

function GroupMemberLinks({ identity }) {
  const members = memberBreweryLinks(identity);
  return (
    <Box>
      {members.map((member) => (
        <MemberBreweryLink key={member.id} member={member} />
      ))}
      <Typography variant="body2">
        <Link component={RouterLink} to="/brewery-groups">
          Brewery groups
        </Link>
      </Typography>
    </Box>
  );
}

function NhStyleFingerprintLinks({ identity }) {
  const isGroup = identity.kind === 'group';
  return (
    <Box sx={{ my: 2 }}>
      <Typography variant="subtitle2" gutterBottom>
        Locations
      </Typography>
      {isGroup ? (
        <GroupMemberLinks identity={identity} />
      ) : (
        <UngroupedBreweryLink identity={identity} />
      )}
    </Box>
  );
}

export default NhStyleFingerprintLinks;
